import React from "react"
import {useTranslation} from "react-i18next"
import {useMediaQuery, useTheme} from "@material-ui/core"

// Context
import {useUiSkin} from "../../context/UiSkinContext"

// Constants
import {UiSkin} from "../../constants"

// Styles
import useStyles from "./styles"

const OPTIONS: Array<{value: UiSkin, labelKey: string}> = [
    {value: "classic", labelKey: "modern.classic"},
    {value: "modern", labelKey: "modern.modern"},
];

/**
 * Rendered inside the CLASSIC header only. The Modern app bar draws its own
 * token-styled equivalent.
 */
export default function UiSkinToggle() {
    const styles = useStyles();
    const [t] = useTranslation("common");
    const {skin, setSkin} = useUiSkin();
    const theme = useTheme();
    const compact = useMediaQuery(theme.breakpoints.down("xs"));
    const target = OPTIONS.filter(option => option.value !== skin)[0];

    if (compact && target !== undefined) {
        return (
          <div className={styles.root}>
              <button
                type="button"
                className={styles.button}
                aria-label={`${t("modern.view_mode")}: ${t(target.labelKey)}`}
                onClick={() => setSkin(target.value)}
              >
                  {t(target.labelKey)}
              </button>
          </div>
        )
    }

    return (
      <div className={styles.root} role="group" aria-label={t("modern.view_mode")}>
          {OPTIONS.map(option => (
            <button
              key={option.value}
              type="button"
              className={`${styles.button} ${skin === option.value ? styles.button__active : ""}`}
              aria-pressed={skin === option.value}
              onClick={() => setSkin(option.value)}
            >
                {t(option.labelKey)}
            </button>
          ))}
      </div>
    )
}
